// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"63":"brandChannelV2","883":"brandChannel","978":"slug"}[chunkId] || chunkId) + "." + {"63":"fa7bf311","543":"2560def1","883":"a43b1d29","978":"815f06f6"}[chunkId] + ".js";
};